import "./view.scss";

document.addEventListener('DOMContentLoaded', function () {
	const sidebar = document.querySelector('.resource-results-sidebar');
	if (!sidebar) return;

	const filterGroups = sidebar.querySelectorAll('.resource-filter-group');
	const clearButton = sidebar.querySelector('.clear');
	const searchForm = sidebar.querySelector('form');

	filterGroups.forEach(group => {
		const content = group.querySelector('.filter-content');
		const summary = document.createElement('p');
		summary.className = 'filter-summary';
		group.querySelector('.filter-header').after(summary);
		const updateSummary = () => { summary.textContent = [...group.querySelectorAll('input:checked')].map(input => input.closest('label')?.querySelector('span')?.textContent.trim()).filter(Boolean).join(', '); };
		const toggleBtn = group.querySelector('.filter-toggle');
		const allCheckbox = group.querySelector('.all-checkbox');
		const checkboxes = group.querySelectorAll('input[type="checkbox"]:not(.all-checkbox)');

		const setOpen = open => {
			group.classList.toggle('is-open', open);
			toggleBtn.setAttribute('aria-expanded', String(open));
			content.hidden = !open;
			summary.hidden = open;
		};
		setOpen(false);
		toggleBtn.addEventListener('click', () => setOpen(!group.classList.contains('is-open')));
		group.addEventListener('change', updateSummary);
		updateSummary();

		// Track active state for CSS visibility
		const updateActiveState = (cb) => {
			if (cb.checked) {
				cb.closest('.filter-checkbox').classList.add('is-active');
			} else {
				cb.closest('.filter-checkbox').classList.remove('is-active');
			}
		};

		if (allCheckbox) {
			updateActiveState(allCheckbox); // Initial state check
			allCheckbox.addEventListener('change', function () {
				if (this.checked) {
					checkboxes.forEach(cb => {
						cb.checked = false;
						updateActiveState(cb);
					});
				} else {
					const anyChecked = Array.from(checkboxes).some(cb => cb.checked);
					if (!anyChecked) {
						this.checked = true;
					}
				}
				updateActiveState(this);
			});
		}

		checkboxes.forEach(checkbox => {
			updateActiveState(checkbox);
			checkbox.addEventListener('change', function () {
				if (this.checked && allCheckbox) {
					allCheckbox.checked = false;
					updateActiveState(allCheckbox);
				}

				const anyChecked = Array.from(checkboxes).some(cb => cb.checked);
				if (!anyChecked && allCheckbox) {
					allCheckbox.checked = true;
					updateActiveState(allCheckbox);
				}
				updateActiveState(this);
			});
		});
	});

	if (clearButton && searchForm) {
		clearButton.addEventListener('click', () => {
			searchForm.querySelector('input[name="term"]').value = '';
			const allCheckboxes = sidebar.querySelectorAll('input[type="checkbox"]');
			allCheckboxes.forEach(cb => {
				if (cb.classList.contains('all-checkbox')) {
					cb.checked = true;
				} else {
					cb.checked = false;
				}
			});
			searchForm.submit();
		});
	}
});
// Result language and layout controls belong in the compiled block asset.
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.coto-resource-library').forEach(block => {
        block.querySelectorAll('.lang-option').forEach(button => button.addEventListener('click', () => {
            if (button.getAttribute('aria-pressed') === 'true') return;
            const url = new URL(window.location.href);
            url.searchParams.set('lang', button.dataset.lang);
            url.searchParams.delete('paging');
            window.location.assign(url.toString());
        }));
        const results = block.querySelector('#resource-results');
        if (!results) return;
        const updatePreviewDescriptions = view => {
            results.querySelectorAll('[data-preview-description]').forEach(link => {
                if (view === 'list') {
                    link.setAttribute('aria-describedby', link.dataset.previewDescription);
                } else {
                    link.removeAttribute('aria-describedby');
                }
            });
        };
        updatePreviewDescriptions(results.classList.contains('list-view') ? 'list' : 'grid');
        block.querySelectorAll('.view-option').forEach(button => button.addEventListener('click', () => {
            const view = button.classList.contains('view-option-list') ? 'list' : 'grid';
            results.classList.toggle('grid-view', view === 'grid');
            results.classList.toggle('list-view', view === 'list');
            updatePreviewDescriptions(view);
            block.querySelectorAll('.view-option').forEach(option => option.setAttribute('aria-pressed', String(option === button)));
            document.querySelectorAll('input[name="view"]').forEach(input => { input.value = view; });
            document.cookie = `resource_view=${view};path=/;max-age=604800;SameSite=Lax`;
            const url = new URL(window.location.href);
            url.searchParams.set('view', view);
            window.history.replaceState(null, '', url.toString());
        }));
    });
});
